/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  AbpPtwExceptionHttpResponseModel,
  CreateOrUpdatePtwCommentDto,
  ODataPostProcessedResultsOfPtwCommentDto,
  PtwCommentDto,
} from '../models/index';
import {
    AbpPtwExceptionHttpResponseModelFromJSON,
    AbpPtwExceptionHttpResponseModelToJSON,
    CreateOrUpdatePtwCommentDtoFromJSON,
    CreateOrUpdatePtwCommentDtoToJSON,
    ODataPostProcessedResultsOfPtwCommentDtoFromJSON,
    ODataPostProcessedResultsOfPtwCommentDtoToJSON,
    PtwCommentDtoFromJSON,
    PtwCommentDtoToJSON,
} from '../models/index';

export interface CreatePtwCommentRequest {
    createOrUpdatePtwCommentDto?: CreateOrUpdatePtwCommentDto;
}

export interface DeletePtwCommentRequest {
    id: string;
}

export interface GetPtwCommentRequest {
    id: string;
}

export interface GetPtwCommentListRequest {
    $filter?: string;
    $search?: string;
    $top?: number;
    $skip?: number;
    $orderby?: string;
}

export interface UpdatePtwCommentRequest {
    id: string;
    createOrUpdatePtwCommentDto?: CreateOrUpdatePtwCommentDto;
}

export interface ValidatePtwCommentRequest {
    createOrUpdatePtwCommentDto?: CreateOrUpdatePtwCommentDto;
}

/**
 * 
 */
export class CommentsApi extends runtime.BaseAPI {

    /**
     * Adds a new entity
     */
    async createPtwCommentRaw(requestParameters: CreatePtwCommentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PtwCommentDto>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/comments`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateOrUpdatePtwCommentDtoToJSON(requestParameters.createOrUpdatePtwCommentDto),
        }, initOverrides);
        if (runtime.hasEmptyBody(response)) {
            return new runtime.VoidApiResponse(response) as any;
        }
        return new runtime.JSONApiResponse(response, (jsonValue) => PtwCommentDtoFromJSON(jsonValue));
    }

    /**
     * Adds a new entity
     */
    async createPtwComment(requestParameters: CreatePtwCommentRequest = {}, errorHandlers?: runtime.ErrorHandlerFunction[], initOverrides?: RequestInit | runtime.InitOverrideFunction) {
        const response = this.createPtwCommentRaw(requestParameters, initOverrides);
        return this.configuration.handleFunction<PtwCommentDto>(response, errorHandlers);
    }

    /**
     * Deletes the entity with the given id.
     */
    async deletePtwCommentRaw(requestParameters: DeletePtwCommentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling deletePtwComment.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/comments/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }

    /**
     * Deletes the entity with the given id.
     */
    async deletePtwComment(requestParameters: DeletePtwCommentRequest, errorHandlers?: runtime.ErrorHandlerFunction[], initOverrides?: RequestInit | runtime.InitOverrideFunction) {
        const response = this.deletePtwCommentRaw(requestParameters, initOverrides);
        return this.configuration.handleFunction<void>(response, errorHandlers);
    }

    /**
     * Returns one entity for detail view.
     */
    async getPtwCommentRaw(requestParameters: GetPtwCommentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PtwCommentDto>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling getPtwComment.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/comments/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        if (runtime.hasEmptyBody(response)) {
            return new runtime.VoidApiResponse(response) as any;
        }
        return new runtime.JSONApiResponse(response, (jsonValue) => PtwCommentDtoFromJSON(jsonValue));
    }

    /**
     * Returns one entity for detail view.
     */
    async getPtwComment(requestParameters: GetPtwCommentRequest, errorHandlers?: runtime.ErrorHandlerFunction[], initOverrides?: RequestInit | runtime.InitOverrideFunction) {
        const response = this.getPtwCommentRaw(requestParameters, initOverrides);
        return this.configuration.handleFunction<PtwCommentDto>(response, errorHandlers);
    }

    /**
     * Returns a list of entities for grid view.
     */
    async getPtwCommentListRaw(requestParameters: GetPtwCommentListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ODataPostProcessedResultsOfPtwCommentDto>> {
        const queryParameters: any = {};

        if (requestParameters.$filter !== undefined) {
            queryParameters['$filter'] = requestParameters.$filter;
        }

        if (requestParameters.$search !== undefined) {
            queryParameters['$search'] = requestParameters.$search;
        }

        if (requestParameters.$top !== undefined) {
            queryParameters['$top'] = requestParameters.$top;
        }

        if (requestParameters.$skip !== undefined) {
            queryParameters['$skip'] = requestParameters.$skip;
        }

        if (requestParameters.$orderby !== undefined) {
            queryParameters['$orderby'] = requestParameters.$orderby;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/comments`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        if (runtime.hasEmptyBody(response)) {
            return new runtime.VoidApiResponse(response) as any;
        }
        return new runtime.JSONApiResponse(response, (jsonValue) => ODataPostProcessedResultsOfPtwCommentDtoFromJSON(jsonValue));
    }

    /**
     * Returns a list of entities for grid view.
     */
    async getPtwCommentList(requestParameters: GetPtwCommentListRequest = {}, errorHandlers?: runtime.ErrorHandlerFunction[], initOverrides?: RequestInit | runtime.InitOverrideFunction) {
        const response = this.getPtwCommentListRaw(requestParameters, initOverrides);
        return this.configuration.handleFunction<ODataPostProcessedResultsOfPtwCommentDto>(response, errorHandlers);
    }

    /**
     * Updates an entity, if existing
     */
    async updatePtwCommentRaw(requestParameters: UpdatePtwCommentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PtwCommentDto>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling updatePtwComment.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/comments/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: CreateOrUpdatePtwCommentDtoToJSON(requestParameters.createOrUpdatePtwCommentDto),
        }, initOverrides);
        if (runtime.hasEmptyBody(response)) {
            return new runtime.VoidApiResponse(response) as any;
        }
        return new runtime.JSONApiResponse(response, (jsonValue) => PtwCommentDtoFromJSON(jsonValue));
    }

    /**
     * Updates an entity, if existing
     */
    async updatePtwComment(requestParameters: UpdatePtwCommentRequest, errorHandlers?: runtime.ErrorHandlerFunction[], initOverrides?: RequestInit | runtime.InitOverrideFunction) {
        const response = this.updatePtwCommentRaw(requestParameters, initOverrides);
        return this.configuration.handleFunction<PtwCommentDto>(response, errorHandlers);
    }

    /**
     * Validates an entity without adding or updating it.
     */
    async validatePtwCommentRaw(requestParameters: ValidatePtwCommentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/comments/validate`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateOrUpdatePtwCommentDtoToJSON(requestParameters.createOrUpdatePtwCommentDto),
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }

    /**
     * Validates an entity without adding or updating it.
     */
    async validatePtwComment(requestParameters: ValidatePtwCommentRequest = {}, errorHandlers?: runtime.ErrorHandlerFunction[], initOverrides?: RequestInit | runtime.InitOverrideFunction) {
        const response = this.validatePtwCommentRaw(requestParameters, initOverrides);
        return this.configuration.handleFunction<void>(response, errorHandlers);
    }

}
